import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown2Fill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.246 12.0872C7.20733 12.0495 7.042 11.9073 6.906 11.7748C6.05067 10.9981 4.65067 8.97177 4.22333 7.91121C4.15467 7.75014 4.00933 7.34293 4 7.12537C4 6.91689 4.048 6.71816 4.14533 6.52852C4.28133 6.29211 4.49533 6.10247 4.748 5.99856C4.92333 5.93167 5.448 5.82775 5.45733 5.82775C6.03133 5.72384 6.964 5.66669 7.99467 5.66669C8.97667 5.66669 9.87133 5.72384 10.454 5.80892C10.4633 5.81866 11.1153 5.92257 11.3387 6.03623C11.7467 6.2447 12 6.65191 12 7.0877V7.12537C11.99 7.40918 11.7367 8.00603 11.7273 8.00603C11.2993 9.00944 9.968 10.989 9.08333 11.7846C9.08333 11.7846 8.856 12.0086 8.714 12.106C8.51 12.258 8.25733 12.3334 8.00467 12.3334C7.72267 12.3334 7.46 12.2483 7.246 12.0872Z",
		fill: "currentColor"
	})
});
export default SvgArrowDown2Fill;
